import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const REVIEWS = [
  {
    name: "Sarah M.",
    place: "Warrenton, VA",
    text: "A massive oak was leaning over our roof after a storm. Kyle came out fast, gave an honest price, and had it down safely without a scratch on the house. Yard was spotless when they left.",
  },
  {
    name: "Dave R.",
    place: "Fauquier County",
    text: "Called three companies — Exterior Nature Care was the only one who actually showed up when they said and did exactly what they quoted. No games, no surprise charges. Hard-working crew.",
  },
  {
    name: "Linda & Tom",
    place: "York County",
    text: "They trimmed and elevated all our trees and cleaned the gutters in one visit. Property honestly looks better than it has in years. Already booked them for next season.",
  },
  {
    name: "Marcus P.",
    place: "Bealeton, VA",
    text: "Technical removal between two houses I thought was impossible. These guys are the real deal — safe, precise, and fair. Can't recommend Kyle enough.",
  },
];

export const Testimonials = () => (
  <section id="reviews" data-testid="testimonials" className="bg-bone py-24 md:py-32 border-t border-stone">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-[1px] w-10 bg-terra" />
            <span className="text-pine/60 text-xs uppercase tracking-[0.3em]">Word of mouth</span>
          </div>
          <Reveal>
            <h2 className="font-display font-extrabold text-pine tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-2xl">
              Homeowners who trust us.
            </h2>
          </Reveal>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={20} className="text-terra" fill="#D35230" />
            ))}
          </div>
          <span className="text-pine font-semibold">5.0 · Local reviews</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={(i % 2) * 0.08}>
            <figure
              data-testid={`review-${i}`}
              className="group h-full border border-stone bg-white p-8 md:p-10 flex flex-col hover:bg-pine transition-colors duration-500"
            >
              <Quote className="text-terra shrink-0" size={30} />
              <blockquote className="mt-5 text-pine/80 group-hover:text-bone/85 text-lg leading-relaxed transition-colors duration-500 flex-1">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-7 flex items-center justify-between">
                <div>
                  <span className="block font-display font-bold text-pine group-hover:text-bone transition-colors duration-500">{r.name}</span>
                  <span className="text-sm text-pine/50 group-hover:text-bone/50 transition-colors duration-500">{r.place}</span>
                </div>
                <div className="flex">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} className="text-terra" fill="#D35230" />
                  ))}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
